module.exports = __webpack_public_path__ + "static/media/logo.3600b0c6.png";